import { Avatar, Drawer } from 'antd';
import useInquiryStaffList from './useInquiryStaffList';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
import ActionsStep from 'features/booking/BookingOnlineV2/ActionsStep';
import img_staff_active from './assets/staff-active.svg';
import clsx from 'clsx';
import { IStaffItemData } from 'services/shop/types/staff';
type StaffBottomSheetProps = {};
export type StaffBottomSheetRef = {
  open: (selected: string[], body: { serviceIds: string[], startTime: string, endTime: string }, onChange: (staff: IStaffItemData) => void) => void;
};
export const useStaffBottomSheet = () => useRef<StaffBottomSheetRef>(null);
const StaffBottomSheet = forwardRef<StaffBottomSheetRef, StaffBottomSheetProps>((_, ref) => {
  const [open, setOpen] = useState(false);
  const [staffList, fetch] = useInquiryStaffList({});
  const selectedRef = useRef<string[]>([]);
  const callbackRef = useRef<(staff: IStaffItemData) => void>(() => undefined);

  const handleChooseStaff = (staff: IStaffItemData) => () => {
    callbackRef.current(staff);
    setOpen(false);
  };

  useImperativeHandle(ref, () => ({
    open: async (selected, body, _callbackRef) => {
      await fetch(body.serviceIds, body.startTime, body.endTime);
      selectedRef.current = selected;
      callbackRef.current = _callbackRef;
      setOpen(true);
    },
  }));

  return (
    <>
      <Drawer contentWrapperStyle={{
        padding: 0, maxWidth: '476px',
        margin: '0 auto',
      }} bodyStyle={{ padding: 0 }} height={'80vh'} width={'476px'} placement="bottom" closable={false} onClose={() => setOpen(false)} open={open}>
        <Container>
          <div className="title-select">Select Staff</div>
          <ContainerList>
            {staffList.map(staff => (
              <button onClick={handleChooseStaff(staff)} key={staff.id} type='button' className={clsx('staff-item', selectedRef.current?.includes(staff.id) && 'active')} >
                <Avatar src={staff.urlImage} size={55} >{staff.firstName?.[0] || 'A'}</Avatar>
                <span className="staff-name">{staff.firstName}</span>
                {selectedRef.current?.includes(staff.id) && <div className="staff-active-icon">
                  <img src={img_staff_active} alt="img_staff_active" style={{ width: 28, height: 28 }} />
                </div>}
              </button>
            ))}
          </ContainerList>
        </Container>
        <ActionsStep onClose={() => setOpen(false)} />
      </Drawer>
    </>
  );
});
StaffBottomSheet.displayName = 'StaffBottomSheet';
export default StaffBottomSheet;

const Container = styled.div`
min-height: 90vh;
.title-select {
  position: sticky;
  top: 0;
  background:#fff;
  padding: 8px 0;
  z-index: 99;
  color: #232F3E;
  text-align: center;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.48px;
}
`;
const ContainerList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
  padding: 0 8px;
  z-index: 2;
  position: relative;
  .staff-item {
    display: flex;
    padding: 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex: 1 0 0;
    border-radius: 7.347px;
    border: 1px solid #C9CDD4;
    background: #FFF;
    position: relative;

    .staff-name {
      color: #1D2129;
      text-align: center;
      font-family: Blinker;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 137.5%; /* 19.25px */
      letter-spacing: 0.28px;
    }

    .staff-active-icon {
      position: absolute;
      right: 4px;
      top: 4px;
    }

    &.active {
      z-index: 99;
      border-radius: 7.347px;
      border: 1px solid #86909C;
      background: #D7EDFF;
    }
  }
`;